import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M30.72 7.73L16.19 2.25V2L15.86 2.12L15.53 2V2.25L1 7.73C1 7.73 1.44 34.74 15.75 35.02V35.03C15.79 35.03 15.82 35.02 15.86 35.02C15.9 35.02 15.93 35.03 15.97 35.03V35.02C30.28 34.74 30.72 7.73 30.72 7.73ZM15.86 24.63C6.92 20.42 4.74 10.59 4.74 10.59L15.86 8.67L26.98 10.59C26.98 10.59 24.79 20.42 15.86 24.63Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M13.1598 23.3298L11.5098 34.2298" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M10.7396 21.6799L7.86963 31.6999" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M9.30986 20.3599L6.10986 29.0599" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M14.1498 2.96997L11.8398 9.56997" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M11.1799 4.07007L7.6499 10.0101" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M8.65006 4.72998L5.56006 10.12" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M18.5503 23.3298L20.2003 34.2298" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M20.9805 21.6799L23.8405 31.6999" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M22.4102 20.3599L25.6002 29.0599" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M17.5601 2.96997L19.8701 9.56997" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M20.54 4.07007L24.06 10.0101" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M23.0698 4.72998L26.1498 10.12" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
    </g>
  )
}
